import React from 'react';
import styled from 'styled-components';

interface BoxProps {
  margin?: number;
  mt?: number;
  ml?: number;
  mr?: number;
  mb?: number;
  style?: React.CSSProperties;
}

/**
 * Testing. Will be moving to Genesis once this component is comprehensive.
 */
const Box = styled.div<BoxProps>(
  props => `
    display: flex;
    margin: ${props.margin ? props.margin : 0};
    margin-top: ${props.mt ? `${props.mt * 8}px` : 0};
    margin-left: ${props.ml ? `${props.ml * 8}px` : 0};
    margin-right: ${props.mr ? `${props.mr * 8}px` : 0};
    margin-bottom: ${props.mb ? `${props.mb * 8}px` : 0};
  `
);

export default React.memo(Box);
